/* eslint-disable radix */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable guard-for-in */
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';

interface FlightSearchRequest {
  flightQuery?: any[];
  travellerCount?: any;
  travelClass?: string;
  airlinePreference?: any[];
  journeyType?: string;
  segmentIndex?: number;
  fullSearchDelay?: number;
  pollingSupported?: number;
  fq?: any;
  requestType?: string;
  requestId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FlightBookingHelperService {
  constructor(private localStorageData: LocalStorageService) {}

  public get getSearchQuery(): FlightSearchRequest {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.FLIGHT_SEARCH_QUERY)
    ) as FlightSearchRequest;
  }

  public set saveSearchQuery(object: FlightSearchRequest) {
    this.localStorageData.setItem(
      localStorageKeys.FLIGHT_SEARCH_QUERY,
      JSON.stringify(object)
    );
  }

  public isSearchQueryExist(key: string): boolean {
    return this.localStorageData.getItem(localStorageKeys.KEY) !== null;
  }

  public removeSearchQuery(key: string) {
    this.localStorageData.removeItem(key);
  }

  searlizeFlightSearchRequest = (bookingQuery) => {
    let url = '';
    for (let key in bookingQuery) {
      switch (key) {
        case 'journeyType':
          url = url.concat('journeyType=', bookingQuery.journeyType, '&');
          break;
        case 'travelClass':
          url = url.concat('travelClass=', bookingQuery.travelClass, '&');
          break;
        case 'airlinePreference':
          url = url.concat('airlinePreference=');
          if (bookingQuery.airlinePreference.length > 0) {
            for (const airline of bookingQuery.airlinePreference) {
              url = url.concat(airline, ',');
              url = url.slice(0, url.length - 1);
            }
          }
          url = url.concat('&');
          break;
        case 'travellerCount':
          url = url.concat('travellerCount=');
          for (key in bookingQuery.travellerCount) {
            url = url.concat(bookingQuery.travellerCount[key], ',');
          }
          url = url.slice(0, url.length - 1);
          url = url.concat('&');
          break;
        case 'flightQuery':
          url = url.concat('flightQuery=');
          for (const eachFlight of bookingQuery.flightQuery) {
            for (key in eachFlight) {
              url = url.concat(eachFlight[key], '_');
            }
            url = url.slice(0, url.length - 1);
            url = url.concat(',');
          }
          url = url.slice(0, url.length - 1);
          url = url.concat('&');
          break;
        default:
          return;
      }
    }
    url = url.slice(0, url.length - 1);
    // return encodeURIComponent(url);
    return url;
  };

  deSerializeFlightSearchRequest(queryUrl) {
    const decodeURL = decodeURIComponent(queryUrl);
    const data = {};

    decodeURL.split('&').forEach((param) => {
      const [key, value] = param.split('=');

      if (key === 'flightQuery') {
        data[key] = value.split(',').map((flight) => {
          const [
            Origin,
            Destination,
            PreferredDepartureTime,
            PreferredArrivalTime,
          ] = flight.split('_');
          return {
            Origin,
            Destination,
            PreferredDepartureTime,
            PreferredArrivalTime,
          };
        });
      } else if (key === 'travellerCount') {
        const [adult, child, infant] = value.split(',');
        data[key] = {
          adult: parseInt(adult),
          child: parseInt(child),
          infant: parseInt(infant),
        };
      } else if (key === 'travelClass') {
        data[key] = value;
      } else if (key === 'airlinePreference') {
        if (value.length > 0) {
          data[key] = value.split(',');
        } else {
          data[key] = [];
        }
      } else if (key === 'journeyType') {
        data[key] = value;
      }
    });
    return data;
  }
}
